jQuery($ => {
    if ($('.a-progress-tracker--incomplete')[0]) {
        $('.a-progress-tracker--incomplete').each(function () {

            var dataColor = $(this).attr('data-color'),
                graph = $(this).find('.a-progress-tracker__graph'),
                complete = $(this).attr('data-complete'),
                total = $(this).attr('data-total'),
                percentage = (complete / total) * 100,
                remaining = total - complete,
                options = [];

            for (var i = 1; i <= complete; i++) {
                options.push({
                    value: percentage,
                    color: dataColor
                });
            }

            for (var i = 1; i <= remaining; i++) {
                options.push({
                    value: percentage,
                    color: '#ffffff'
                });
            }

            graph.drawPieChart(options);
        });
    }
});